import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
    }

    disconnect() {
        super.disconnect();
    }
}
